import { render, staticRenderFns } from "./BasePopupEditor.vue?vue&type=template&id=052b4835&scoped=true&"
import script from "./BasePopupEditor.vue?vue&type=script&lang=js&"
export * from "./BasePopupEditor.vue?vue&type=script&lang=js&"
import style0 from "./BasePopupEditor.vue?vue&type=style&index=0&id=052b4835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b4835",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('052b4835')) {
      api.createRecord('052b4835', component.options)
    } else {
      api.reload('052b4835', component.options)
    }
    module.hot.accept("./BasePopupEditor.vue?vue&type=template&id=052b4835&scoped=true&", function () {
      api.rerender('052b4835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePopupEditor.vue"
export default component.exports